import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import type { SettingItemKey } from '../constants';
import { useLogClickItem } from './useLogClickItem';

export const useOnPressSettingItem = () => {
  const { openDeeplink } = useOpenDeeplink();
  const logClickItem = useLogClickItem();

  return useCallback(
    (key: SettingItemKey) => {
      logClickItem(key);

      switch (key) {
        case 'profile':
          openDeeplink('ably://webview?url=mypage/profile');
          return;

        case 'shippingAddress':
          openDeeplink('ably://address');
          return;

        case 'personalization':
          openDeeplink(
            `ably://react/App?screen=MyPersonalization&extras=${encodeURIComponent(
              JSON.stringify({ from: 'SETTING' }),
            )}`,
          );
          return;

        case 'ablyPay':
          openDeeplink('ably://webview?title_bar=false&url=ably-pay/setting');
          return;

        case 'poc':
          openDeeplink('ably://react/App?screen=PointOfContact');
          return;

        case 'alarm':
          // openDeeplink('ably://alarm_settings');
          openDeeplink('ably://react/App?screen=AlarmSetting');
          return;

        case 'logout':
          bridge
            .logout()
            .then(() => bridge.toast('로그아웃 되었습니다'))
            .catch(() => bridge.toast('로그아웃에 실패했어요. 다시 시도해주세요.'));
          return;
      }
    },
    [openDeeplink, logClickItem],
  );
};
